import { getProductRecommendationsInputSchema } from "@redotech/redo-product-common/recommendations";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getProductRecommendations = unaryRpc({
  name: "getProductRecommendations",
  input: getProductRecommendationsInputSchema,
  output: z.object({
    products: z.array(
      z.object({
        product_id: z.string(),
        title: z.string().nullable(),
        featuredImage: z.object({ url: z.string() }).nullable(),
        productLink: z.string().nullable(),
        price: z
          .object({
            minVariantPrice: z.object({
              amount: z.string(),
              currencyCode: z.string(),
            }),
            maxVariantPrice: z.object({
              amount: z.string(),
              currencyCode: z.string(),
            }),
          })
          .nullable(),
        vendor: z.string().nullable(),
      }),
    ),
  }),
});
